<template>
  <ValidationProvider rules="required" slim v-slot="state">
    <div :class="validationState(state)" class="lib__field">
      <div class="lib__tiles lib__tiles--inline">
        <TileRadio :group="fieldId" item="individual" :label="$t('contact.type.individual')" v-model="selection" data-cy="tile-individual-contact"></TileRadio>
        <TileRadio :group="fieldId" item="freelance" :label="$t('contact.type.freelance')" v-model="selection" data-cy="tile-freelance-contact"></TileRadio>
        <TileRadio :group="fieldId" item="company" :label="$t('contact.type.company')" v-model="selection" data-cy="tile-company-contact"></TileRadio>
      </div>
      <error-message :error="state.errors[0]" data-cy="contact-type-error-message"></error-message>
    </div>
  </ValidationProvider>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { ContactType } from '@/models'
import FieldBox from '@/components/inputs/Shared/FieldBox'

@Component({
  name: 'configuration-type-selector'
})
export default class ContactTypeSelector extends FieldBox {
  //#region [Property]
  @Prop({ type: String, required: false }) public readonly value!: ContactType | null
  //#endregion

  //#region [Computed]
  public get selection(): ContactType | null {
    return this.value
  }

  public set selection(val: ContactType | null) {
    this.change(val)
  }
  //#endregion

  //#region [Emit]
  @Emit('input')
  public change(value: ContactType | null): ContactType | null {
    return value
  }
  //#endregion
}
</script>